// Mock data for NeighborNet AI

export const needs = [
  {
    id: "n1",
    title: "Groceries for elderly neighbor",
    category: "Food",
    urgency: "high",
    location: "Brooklyn, NY",
    postedBy: "Amina R.",
    postedAt: "2h ago",
    description: "Mrs. Patel is recovering from surgery and needs weekly grocery delivery.",
    responses: 4,
    tag: "food",
  },
  {
    id: "n2",
    title: "Ride to medical appointment",
    category: "Transport",
    urgency: "medium",
    location: "Austin, TX",
    postedBy: "James O.",
    postedAt: "5h ago",
    description: "Need transportation Thursday morning for a dialysis appointment.",
    responses: 2,
    tag: "transport",
  },
  {
    id: "n3",
    title: "Math tutoring for 8th grader",
    category: "Education",
    urgency: "low",
    location: "Nairobi, KE",
    postedBy: "Grace M.",
    postedAt: "1d ago",
    description: "Looking for a volunteer tutor 1x/week for pre-algebra help.",
    responses: 7,
    tag: "education",
  },
  {
    id: "n4",
    title: "Winter coats for shelter",
    category: "Clothing",
    urgency: "high",
    location: "Toronto, CA",
    postedBy: "Hope Shelter",
    postedAt: "3d ago",
    description: "Collecting winter coats (all sizes) for our shelter residents.",
    responses: 12,
    tag: "clothing",
  },
];

export const offers = [
  {
    id: "o1",
    title: "Free legal consultation (immigration)",
    category: "Professional",
    location: "Remote",
    postedBy: "Diana Cho, Esq.",
    postedAt: "1h ago",
    description: "Offering 30-min free consultations to immigrants navigating paperwork.",
    slots: 5,
  },
  {
    id: "o2",
    title: "Weekend carpentry help",
    category: "Skills",
    location: "Portland, OR",
    postedBy: "Marco B.",
    postedAt: "6h ago",
    description: "Handy with wood, tools, and repairs. Saturdays 9am-2pm.",
    slots: 3,
  },
  {
    id: "o3",
    title: "Home-cooked meals delivered",
    category: "Food",
    location: "Chicago, IL",
    postedBy: "Sunday Kitchen Co-op",
    postedAt: "2d ago",
    description: "Delivering 20 warm meals every Sunday to families in need.",
    slots: 20,
  },
];

export const volunteers = [
  {
    id: "v1",
    org: "Global Food Bank",
    role: "Food Sorter",
    commitment: "4 hrs / week",
    location: "New York, USA",
    skills: ["Physical", "Team"],
    image: "https://images.pexels.com/photos/6647015/pexels-photo-6647015.jpeg",
  },
  {
    id: "v2",
    org: "Youth Literacy Project",
    role: "Reading Buddy",
    commitment: "2 hrs / week",
    location: "Remote",
    skills: ["Teaching", "Patient"],
    image: "https://images.unsplash.com/photo-1544717305-2782549b5136?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "v3",
    org: "Green Streets Initiative",
    role: "Community Gardener",
    commitment: "3 hrs / weekend",
    location: "London, UK",
    skills: ["Outdoor", "Physical"],
    image: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "v4",
    org: "SeniorConnect",
    role: "Companion Caller",
    commitment: "1 hr / week",
    location: "Remote",
    skills: ["Empathy", "Communication"],
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=800&q=80",
  },
];

export const jobs = [
  {
    id: "j1",
    title: "Community Outreach Coordinator",
    company: "Hopewell NGO",
    type: "Full-time",
    pay: "$52k / yr",
    location: "Nairobi, KE",
    posted: "2d ago",
    tags: ["Nonprofit", "On-site"],
  },
  {
    id: "j2",
    title: "Weekend Delivery Driver",
    company: "Sunday Kitchen Co-op",
    type: "Gig",
    pay: "$25 / hr",
    location: "Chicago, IL",
    posted: "5h ago",
    tags: ["Flexible", "Weekly"],
  },
  {
    id: "j3",
    title: "Grant Writer (freelance)",
    company: "Youth Literacy Project",
    type: "Contract",
    pay: "$40-60 / hr",
    location: "Remote",
    posted: "1w ago",
    tags: ["Remote", "Writing"],
  },
  {
    id: "j4",
    title: "Bilingual Case Manager",
    company: "New Roots Coalition",
    type: "Part-time",
    pay: "$28 / hr",
    location: "Toronto, CA",
    posted: "3d ago",
    tags: ["Bilingual", "Social work"],
  },
];

export const foodPrograms = [
  {
    id: "f1",
    name: "Sunday Community Kitchen",
    type: "Weekly meals",
    served: 2400,
    location: "Chicago, IL",
    status: "accepting-help",
  },
  {
    id: "f2",
    name: "Downtown Food Pantry",
    type: "Grocery pickups",
    served: 8100,
    location: "New York, NY",
    status: "accepting-donations",
  },
  {
    id: "f3",
    name: "Rural Farm Share",
    type: "Fresh produce",
    served: 3600,
    location: "Iowa, USA",
    status: "accepting-help",
  },
  {
    id: "f4",
    name: "School Backpack Meals",
    type: "Weekend backpacks",
    served: 1200,
    location: "Nairobi, KE",
    status: "accepting-donations",
  },
];

export const mentors = [
  {
    id: "m1",
    name: "Dr. Priya Anand",
    field: "Data Science & Careers",
    experience: "12 years",
    location: "Bangalore, IN",
    rating: 4.9,
    reviews: 87,
    avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=400&q=80",
    bio: "Helped 200+ students break into tech careers. Free 1:1 sessions for underrepresented groups.",
  },
  {
    id: "m2",
    name: "Kwame Owusu",
    field: "Small Business & Entrepreneurship",
    experience: "20 years",
    location: "Accra, GH",
    rating: 4.8,
    reviews: 54,
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=400&q=80",
    bio: "Serial founder mentoring first-time business owners in emerging markets.",
  },
  {
    id: "m3",
    name: "Sofia Rojas",
    field: "College Applications",
    experience: "8 years",
    location: "Mexico City, MX",
    rating: 5.0,
    reviews: 121,
    avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=400&q=80",
    bio: "Former admissions officer. Guides first-gen students through college essays.",
  },
  {
    id: "m4",
    name: "Ahmed Farah",
    field: "Career Transitions",
    experience: "15 years",
    location: "London, UK",
    rating: 4.9,
    reviews: 63,
    avatar: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=400&q=80",
    bio: "Helping refugees and immigrants navigate their next career chapter.",
  },
];

export const stats = {
  neighborsHelped: 128420,
  activeVolunteers: 12384,
  countries: 47,
  mealsDelivered: 384210,
  matchesMade: 22118,
  jobsFilled: 3241,
};

export const impactByMonth = [
  { month: "Sep", helps: 3200, needs: 4100 },
  { month: "Oct", helps: 4100, needs: 4400 },
  { month: "Nov", helps: 5200, needs: 5000 },
  { month: "Dec", helps: 6800, needs: 6100 },
  { month: "Jan", helps: 7400, needs: 6900 },
  { month: "Feb", helps: 8900, needs: 8100 },
];

export const categoryDistribution = [
  { name: "Food", value: 34 },
  { name: "Jobs", value: 22 },
  { name: "Mentorship", value: 18 },
  { name: "Volunteer", value: 15 },
  { name: "Emergency", value: 11 },
];

export const aiRecommendations = [
  {
    id: "r1",
    matchType: "You can help",
    title: "Ride to medical appointment",
    reason: "You're 1.2 mi away and drive a car — perfect match.",
    score: 96,
    category: "Transport",
  },
  {
    id: "r2",
    matchType: "You may need",
    title: "Free tax filing workshop nearby",
    reason: "Based on your recent search for financial support.",
    score: 88,
    category: "Finance",
  },
  {
    id: "r3",
    matchType: "Mentor match",
    title: "Kwame Owusu — Small Business",
    reason: "Aligned with your goal to start a bakery in your neighborhood.",
    score: 92,
    category: "Mentorship",
  },
];

export const recentActivity = [
  { id: "a1", user: "Amina R.", action: "responded to your food request", time: "12m ago" },
  { id: "a2", user: "Marco B.", action: "offered carpentry help", time: "1h ago" },
  { id: "a3", user: "Sofia Rojas", action: "accepted your mentorship request", time: "3h ago" },
  { id: "a4", user: "Global Food Bank", action: "invited you to volunteer", time: "1d ago" },
];
